import { Box, Button } from "@mui/material";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import PageContentEditor from "../../../../../components/PageContentEditor";
import { DataCodeEnum } from "../../../../../constants/enum";

const WhatIs = () => {
  return (
    <PageContentEditor
      dataCode={DataCodeEnum.WHAT_IS_NUMEROLOGY}
      dataName={"What is numerology?"}
    />
  );
};

export default WhatIs;
